<template>
  <div class="tags_view_container">
    <nav-scroll-box class="scroll_box" ref="navScroll">
      <router-link
        v-for="item in visitedViews"
        ref="tagItem"
        :key="item.path"
        class="tag_item"
        :class="{ active: item.path === route.path }"
        :to="{
          path: item.path,
          query: item.query,
          fullPath: item.fullPath || item.path,
        }"
        @click="handleClick(item)"
      >
        <div class="tag_name">{{ item.meta?.title ?? item.name }}</div>
        <div
          v-if="homeView.path !== item.path"
          class="delete_btn"
          @click.stop.prevent="deleteTag(item, item.path === route.path)"
        >
          <em
            ><el-icon style="line-height: 18px; color: rgb(210, 210, 210)"><Close /></el-icon
          ></em>
        </div>
      </router-link>
    </nav-scroll-box>
    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <li v-show="contextSelectedView.path !== homeView.path" @click.stop="closeView">关闭</li>
      <li @click.stop="closeOtherViews">关闭其他</li>
      <li @click.stop="closeAllViews">关闭所有</li>
    </ul>
  </div>
</template>
<script setup lang="ts" name="TagsView">
import { nextTick, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Close } from '@element-plus/icons-vue';
import pinia from '@/stores/store';
import { tagViewStore } from '@/stores/tagsView';
import NavScrollBox from './NavScrollBox.vue';

const visible = ref(false);
const tagItem = ref();
const navScroll = ref();
const tagViewStores = tagViewStore(pinia);
const router = useRouter();
const route = useRoute();
const top = ref(0);
const left = ref(0);
const contextSelectedView = ref({ path: '' });
const contextIsActive = ref(false);
const pathArr = ref(['/404', '/login', '/500', '/']);
const emit = defineEmits(['viewClick']);

interface Name {
  name?: string;
  title?: string; // 添加title属性
}
interface Path {
  path: string;
  query?: string;
  fullPath?: string;
  meta?: Name;
  name?: string;
}
const visitedViews = ref<Array<Path>>(tagViewStores.visitedViews);
const homeView = ref(tagViewStores.homeView);
watch(route, () => {
  addTag();
  moveToCurrentTag();
});
watch(visible, val => {
  if (val) {
    document.body.addEventListener('click', closeMenu);
  } else {
    document.body.removeEventListener('click', closeMenu);
  }
});
onMounted(() => {
  addTag();
});

const moveToCurrentTag = () => {
  const tagItems = tagItem.value;
  nextTick(() => {
    for (const tag of tagItems) {
      if (tag.to.path === route.path) {
        navScroll.value.moveToTarget(tag);
        // 如果query不同，则触发visitedRoute update
        if (tag.to.fullPath !== route.fullPath) {
          tagViewStores.updateVisitedView(route);
        }
        break;
      }
    }
  });
};
const handleClick = item => {
  emit('viewClick', item.path);
};
// 添加标签
const addTag = () => {
  // 如果是首页则忽略
  // if (route.path === tagViewStores.homeView.path) return;
  if (pathArr.value.includes(route.path)) return;
  // 添加view
  tagViewStores.addView(route);
};
// 删除标签
const deleteTag = (view, isActive) => {
  if (isActive) {
    // 如果点击的是选中的标签
    tagViewStores.deleteView(view);
    router.push(visitedViews.value[visitedViews.value.length - 1].path);
    emit('viewClick', visitedViews.value[visitedViews.value.length - 1].path);
  } else {
    // 如果点击的不是选中的标签
    tagViewStores.deleteView(view);
  }
};
// // 打开菜单栏
// const openMenu = (view, e, isActive) => {
//   const menuMinWidth = 105;
//   // const offsetLeft = $el.getBoundingClientRect().left; // container margin left
//   // const offsetWidth = $el.offsetWidth; // container width
//   const maxLeft = offsetWidth - menuMinWidth; // left boundary
//   // const left = e.clientX - offsetLeft + 150; // 15: margin right

//   if (left > maxLeft) {
//     left.value = maxLeft;
//   } else {
//     left.value = left;
//   }

//   top.value = e.clientY;
//   visible.value = true;

//   // 设置被右击菜单的状态
//   contextSelectedView.value = view;
//   contextIsActive.value = isActive;
// };
// 关闭菜单栏
const closeMenu = () => {
  visible.value = false;
};

// 关闭
const closeView = () => {
  // 关闭菜单
  closeMenu();
  deleteTag(contextSelectedView.value, contextIsActive.value);
};

// 刷新菜单栏的相关状态;
const refreshMenuContext = () => {
  // 重置菜单栏的状态
  contextSelectedView.value = { path: '' };
  contextIsActive.value = false;
};

// 关闭其他
const closeOtherViews = () => {
  // 关闭菜单
  closeMenu();

  // 如果点击的不是选中的标签;
  tagViewStores.deleteOtherViews(contextSelectedView.value).then(() => {
    router.push(contextSelectedView.value.path);
    emit('viewClick', contextSelectedView.value.path);
    refreshMenuContext();
  });
  tagViewStores.deleteOtherViews(contextSelectedView.value).then(() => {
    router.push(contextSelectedView.value.path);
    emit('viewClick', contextSelectedView.value.path);
    refreshMenuContext();
  });
};

// 关闭所有
const closeAllViews = () => {
  // 关闭菜单
  closeMenu();
  tagViewStores.deleteAllViews().then(() => {
    router.push(visitedViews.value[visitedViews.value.length - 1].path);
    emit('viewClick', visitedViews.value[visitedViews.value.length - 1].path);
    refreshMenuContext();
  });
};
</script>
<style lang="scss" scoped>
.tags_view_container {
  min-height: 35px;
  height: auto;
  .scroll_box {
    padding-right: 10px;
    border-bottom: 1px solid rgb(255, 255, 255);
    min-height: 35px;
    height: auto;
    line-height: 35px;
    background-color: rgb(255, 255, 255);
    ::v-deep .el-scrollbar__wrap {
      height: auto;
    }
    .tag_item {
      display: inline-flex;
      align-items: center;
      height: auto;
      min-height: 25px;
      line-height: 25px;
      border: 1px solid #eee;
      border-radius: 3px;
      padding: 0;
      cursor: pointer;
      padding-left: 10px;
      padding-right: 8px;
      text-decoration: none;
      margin-left: 10px;
      margin-top: 5px;
      margin-bottom: 5px;
      white-space: nowrap;
      &.active {
        padding-left: 4px;
        background-color: #409eff;
        .tag_name {
          color: #fff;
          height: 100%;
        }
        .delete_btn {
          &:hover {
            background-color: #b5daff;
            i {
              color: rgb(255, 255, 255);
            }
          }
          i {
            color: rgb(255, 255, 255);
          }
        }
      }

      .tag_name {
        font-size: 14px;
        vertical-align: middle;
        color: #666;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 120px;
      }
      .delete_btn {
        display: inline-block;
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-left: 4px;
        border-radius: 50%;
        font-size: 0;
        line-height: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background-color: #b5daff;
          i {
            color: rgb(255, 255, 255);
          }
        }
        i {
          font-size: 12px;
          transform: translateX(1px) translateY(-1px);
          display: block;
        }
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>
